import FullBanner from './FullBanner';

export default FullBanner;
